import { useState, useEffect } from 'react';
import { navItems } from '@/mocks/homepage';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/80 backdrop-blur-xl border-b border-background-200/60'
            : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between h-16 md:h-18 px-4 md:px-8">
          <a href="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-heading font-black text-foreground-950 tracking-tight">
              爆料专区
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.slug}
                href={`/category/${item.slug}`}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg hover:bg-background-100 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => setSearchOpen(true)}
              className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-foreground-950 transition-colors rounded-lg hover:bg-background-100 ml-2 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(true)}
              className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-foreground-950 transition-colors rounded-lg hover:bg-background-100 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <a
              href="#"
              className="hidden md:inline-flex items-center px-5 py-2.5 bg-foreground-950 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              投稿爆料
            </a>
          </div>
        </div>
      </nav>

      {searchOpen && (
        <div className="fixed inset-0 z-[60] flex items-start justify-center pt-24 px-4">
          <div
            className="absolute inset-0 bg-foreground-950/40 backdrop-blur-sm"
            onClick={() => setSearchOpen(false)}
          />
          <div className="relative w-full max-w-xl bg-background-50 rounded-2xl overflow-hidden">
            <div className="flex items-center px-5 py-4 border-b border-background-200">
              <i className="ri-search-line text-lg text-foreground-400 mr-3"></i>
              <input
                type="text"
                placeholder="搜索爆料、明星、事件..."
                className="flex-1 bg-transparent text-foreground-950 text-base outline-none placeholder:text-foreground-400"
                autoFocus
              />
              <button
                onClick={() => setSearchOpen(false)}
                className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <div className="px-5 py-4">
              <p className="text-xs text-foreground-500 mb-3">热门搜索</p>
              <div className="flex flex-wrap gap-2">
                {['直播翻车', '学历造假', '恋情曝光', '综艺内幕', '品牌违规'].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 bg-background-100 text-foreground-700 text-sm rounded-full hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}